import React, {useEffect} from 'react';
import {StyleSheet} from 'react-native';
import {Box, HStack, Heading, Pressable, Text, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useSalesmanContext} from '../../../../../../../context/salesman';
import {StackParamList} from '../../../../../../../navigators';
import InternalTemplate from '../../../../../../../components/templates/internal';
import {IInvoiceItem} from '../../../../../../../interfaces/dtos/invoice-item.interface';
import {PrimaryButton} from '../../../../../../../components/buttons';
import {formatMoney} from '../../../../../../../utils/format';
import {message as t} from '../../../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'InvoiceAdjustableItems'
>;

const InvoiceAdjustableItems = ({navigation}: ScreenProps) => {
  const {
    invoiceCandidate,
    setInvoiceRequest,
    invoiceRequest,
    setInvoiceItemEditing,
  } = useSalesmanContext();

  useEffect(() => {
    if (invoiceCandidate?.items) {
      setInvoiceRequest({
        orderId: invoiceCandidate.document,
        items: invoiceCandidate?.items.map(item => {
          return {...item};
        }),
        date: new Date(),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoBack = () => {
    navigation.goBack();
  };

  const handleOnPressChange = (position: number) => {
    if (
      invoiceRequest &&
      invoiceRequest?.items &&
      invoiceRequest?.items.length
    ) {
      setInvoiceItemEditing(invoiceRequest?.items[position]);
      navigation.navigate('InvoiceItemForm');
    }
  };

  const handleOnContinuePress = () => {
    navigation.navigate('InvoiceSummary');
  };

  return (
    <InternalTemplate
      title={'salesman-invoice-adjustable-items-title'}
      contentPaddingX="3"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <VStack paddingX={5}>
        <Box mb="30" mt="30">
          {invoiceRequest?.items &&
            invoiceRequest?.items.map((item: IInvoiceItem, index: number) => {
              return (
                <HStack key={`item-${index}`} style={styles.itemBox}>
                  <Pressable onPress={() => handleOnPressChange(index)}>
                    <HStack width={'90%'}>
                      <VStack style={styles.itemInfoBox} width={'70%'}>
                        <Heading style={styles.productTitle}>
                          {item.product.title}
                        </Heading>
                        <Box style={styles.boxItemUnits}>
                          <Text style={styles.itemUnits}>
                            {`${item.unit.title}(s)`}:
                          </Text>
                          <Text style={styles.itemCount}> {item.count}</Text>
                        </Box>
                        <Text style={styles.itemUnits}>
                          {item.unit.subUnit.size} {item.unit.subUnit.title}
                        </Text>
                        <Text style={styles.itemUnitPrice}>
                          {t('salesman-invoice-adjustable-item-price-title')}
                          {formatMoney(
                            item.price,
                            invoiceCandidate?.currency === 'BS' ? 'Bs' : '$',
                          )}
                        </Text>
                      </VStack>
                      <VStack
                        style={styles.itemValueBox}
                        justifyItems={'flex-end'}
                        width={'30%'}>
                        <Heading style={styles.itemPrice}>
                          {formatMoney(
                            item.price * item.count,
                            invoiceCandidate?.currency === 'BS' ? 'Bs' : '$',
                          )}
                        </Heading>
                      </VStack>
                    </HStack>
                  </Pressable>
                </HStack>
              );
            })}
        </Box>
        <PrimaryButton
          label="salesman-invoice-adjustable-item-continue-button"
          onPress={handleOnContinuePress}
        />
      </VStack>
    </InternalTemplate>
  );
};

export default InvoiceAdjustableItems;

const styles = StyleSheet.create({
  itemBox: {
    borderColor: '#0000001e',
    borderBottomWidth: 1,
    width: '100%',
    paddingBottom: 10,
    paddingTop: 10,
  },
  itemInfoBox: {
    paddingTop: 10,
    paddingLeft: 5,
  },
  itemValueBox: {paddingTop: 10},
  productTitle: {
    fontSize: 16,
    textAlign: 'left',
    paddingLeft: 5,
  },
  boxItemUnits: {
    color: '#00000099',
    textAlign: 'left',
    fontSize: 14,
    display: 'flex',
    flexDirection: 'row',
  },
  itemUnits: {
    color: '#00000099',
    textAlign: 'left',
    paddingLeft: 5,
    fontSize: 14,
  },
  itemPrice: {
    fontSize: 16,
    color: '#000000DE',
    textAlign: 'right',
    paddingRight: 2,
  },
  itemUnitPrice: {
    fontSize: 14,

    color: '#000000DE',
    textAlign: 'left',
    paddingRight: 2,
    paddingLeft: 5,
  },
  itemCount: {
    color: '#000000DE',
    textAlign: 'right',
    paddingLeft: 2,
    fontSize: 14,
  },
});
